import React from 'react';
import { NavLink } from 'react-router-dom';
import './Home.css';
import translations from './lang';

export function Home() {
  const language = localStorage.getItem('language') || 'ro';
  const t = translations[language] || {};
  const _t = (k, d) => t[k] || d;

  return (
    <div className="home">
      {/* HERO */}
      <section className="home-hero">
        <div className="home-hero-inner">
          <span className="home-badge">{_t('home_badge', 'Servicii • Programări • Simplu')}</span>
          <h1 className="home-title">
            {_t('home_hero_title', 'Foglalj időpontot pillanatok alatt')}
          </h1>
          <p className="home-subtitle">
            {_t('home_hero_subtitle', 'Találd meg a megfelelő szolgáltatót és foglalj online – gyorsan, átláthatóan, 0 stresszel.')}
          </p>
          <div className="home-cta">
            <NavLink to="/services" className="btn btn-primary">
              {_t('home_cta_browse', 'Böngéssz szolgáltatások között')}
            </NavLink>
            <NavLink to="/login" className="btn btn-ghost">
              {_t('home_cta_register', 'Csatlakozz szolgáltatóként')}
            </NavLink>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section className="home-section">
        <h2 className="home-section-title">
          {_t('features_title', 'Miért a MyServiceHub?')}
        </h2>

        <div className="home-features">
          <div className="card">
            <div className="icon">
              <svg viewBox="0 0 24 24"><path d="M8 7h8v2H8zM8 11h8v2H8zM8 15h8v2H8z"/><path d="M21 7h-3V3H6v4H3v14h18V7zM8 5h8v2H8V5zm11 14H5V9h14v10z"/></svg>
            </div>
            <h3>{_t('feature_1_title', 'Átlátható foglalás')}</h3>
            <p>{_t('feature_1_desc', 'Valós idejű elérhetőség, egyértelmű árak és időtartamok.')}</p>
          </div>

          <div className="card">
            <div className="icon">
              <svg viewBox="0 0 24 24"><path d="M12 2a5 5 0 015 5v2h2a3 3 0 013 3v8a3 3 0 01-3 3H8a3 3 0 01-3-3V12a3 3 0 013-3h2V7a5 5 0 015-5z"/></svg>
            </div>
            <h3>{_t('feature_2_title', 'Értesítések')}</h3>
            <p>{_t('feature_2_desc', 'Email/SMS emlékeztetők, hogy semmi ne maradjon le.')}</p>
          </div>

          <div className="card">
            <div className="icon">
              <svg viewBox="0 0 24 24"><path d="M3 13h4v8H3v-8zm7-6h4v14h-4V7zm7-4h4v18h-4V3z"/></svg>
            </div>
            <h3>{_t('feature_3_title', 'Statisztikák a profiknak')}</h3>
            <p>{_t('feature_3_desc', 'Legnépszerűbb szolgáltatások, forgalmas időszakok – minden egy helyen.')}</p>
          </div>

          <div className="card">
            <div className="icon">
              <svg viewBox="0 0 24 24"><path d="M12 7l5 5-5 5-1.41-1.41L13.17 13H4v-2h9.17l-2.58-2.59L12 7z"/></svg>
            </div>
            <h3>{_t('feature_4_title', 'Villámgyors kezdés')}</h3>
            <p>{_t('feature_4_desc', 'Pár kattintás és már fogadhatod is a foglalásokat.')}</p>
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="home-section">
        <h2 className="home-section-title">
          {_t('how_title', 'Hogyan működik?')}
        </h2>

        <div className="home-steps">
          <div className="step">
            <span className="step-num">1</span>
            <h4>{_t('how_1_title', 'Keresés')}</h4>
            <p>{_t('how_1_desc', 'Válassz kategóriát és böngéssz a szolgáltatók között.')}</p>
          </div>
          <div className="step">
            <span className="step-num">2</span>
            <h4>{_t('how_2_title', 'Foglalás')}</h4>
            <p>{_t('how_2_desc', 'Válaszd ki az időpontot és foglald le egy pillanat alatt.')}</p>
          </div>
          <div className="step">
            <span className="step-num">3</span>
            <h4>{_t('how_3_title', 'Értesítés')}</h4>
            <p>{_t('how_3_desc', 'Emlékeztetőt küldünk, hogy biztosan ott legyél időben.')}</p>
          </div>
        </div>
      </section>

 

      {/* CTA BANNER */}
      <section className="home-cta-banner">
        <div className="cta-inner">
          <h3>{_t('cta_banner_title', 'Kezdd el most!')}</h3>
          <p>{_t('cta_banner_subtitle', 'Hozz létre profilt vagy böngéssz a szolgáltatások között.')}</p>
          <div className="cta-actions">
            <NavLink to="/services" className="btn btn-light">{_t('cta_banner_btn_browse', 'Szolgáltatások')}</NavLink>
            <NavLink to="/login" className="btn btn-dark">{_t('cta_banner_btn_register', 'Regisztráció')}</NavLink>
          </div>
        </div>
      </section>
    </div>
  );
}
